export default __webpack_public_path__ + "static/media/22.205de369.png";